import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export const Header = withSuspense(
	lazy(() => import('./header.component')),
	null,
);
